export default function InvoicesUpdates(){
    return(
        <>
<p>Tesxt</p>
        </>
    )
}


